<template>
<div class="text-left nav-wrapper px-3">

    <div>
      <div class="nav-item-left-wrapper">
        <b-button
          v-if="details.org_details.organization_name != 'Quicktest'"
          v-b-toggle.sidebar-dash
          variant="outline-info"
          class="sbb"
        >
          <b-icon-text-left font-scale="2"></b-icon-text-left>
        </b-button>

        <b-button
          v-if="details.org_details.organization_name == 'Quicktest'"
          v-b-toggle.admin-nav2
          variant="outline-success"
          class="sbb"
        >
          <b-icon-text-left font-scale="2"></b-icon-text-left>
        </b-button>
  
        <h3 class="ml-3 mt-2 module-text">{{ currentmodule }}</h3>
      </div>
  
      <b-sidebar
        id="sidebar-dash"
        title="Dashboard"
        backdrop-variant="dark"
        width="300px"
        backdrop
        shadow
      >
        <template #default>
          <orgDashboardNavLinks class="navbody" navbody="navbody"></orgDashboardNavLinks>
        </template>
      </b-sidebar>
    </div>
    

    <div>
      <div class="link-nav">
        <b-sidebar title="Admin Functions" id="admin-nav2" shadow>
            <template #default="clearance">
                <adminNavLinks class="link-nav" :clearance="clearance" :level="level" navbody="navbody"></adminNavLinks>
            </template>
            
        </b-sidebar>
      </div>
    </div>
    
    <div>
      <b-modal
        id="modal-logout"
        centered
        title="Confirm Exit"
        ok
        ok-variant="success"
        @cancel="hide2nd()"
        cancel-variant="danger"
        @ok="loggingOut()"
      >
        <template v-slot:modal-ok> Yes, Logout </template>
        <p>Are You sure you want to Logout?</p>
      </b-modal>
      <img class="img-dp" :src="details.profileimage" />

      <b-dropdown
        v-if="Object.keys(details).length > 0"
        class="ml-2 ml-lg-2 dropdown-button"
        right
        variant="light"
        :text="
          details.fname +
            ' ' +
            details.lname.substring(0, 1)
        "
      >
        <b-dropdown-item :to="{ name: 'updateprofile' }"
          >View Profile</b-dropdown-item
        >
        <b-dropdown-item @click="confirmLogout()"
          >Log Out</b-dropdown-item
        >
      </b-dropdown>
    </div>
    
</div>
</template>

<script>
import { mapActions,mapState } from "vuex";
// import adminNavLinks from "@/components/admin/adminNavLinks"
import orgDashboardNavLinks from "@/components/organization/orgDashboardNavLinks";
import adminNavLinks from "@/components/admin/adminNavLinks"

export default {
    components : {
      orgDashboardNavLinks,
      adminNavLinks
    },
    props: ["clearance", "level"],
    computed: {
      ...mapState({
        details: (state) => state.loginmaster.details,
        loggedin: (state) => state.loginmaster.loggedIn,
        environ: (state) => state.loginmaster.environ,
        currentmodule: (state) => state.admin.currentmodule,
      }),
    },
    methods : {
      ...mapActions(["logOut"]),
      logout() {
        if (
          confirm("Are you sure you want to log out? Saved Changes may be lost")
        ) {
          this.logOut().then(() => {
            this.$router.push({
              name: "login"
            });
          });
        }
      },
      loggingOut() {
        let now = new Date();
        now.setFullYear(now.getFullYear() - 20);
        document.cookie = `remember=;expires=${now.toUTCString()}`;
        document.cookie = `qid=;expires=${now.toUTCString()}`;
        this.logOut().then(() => {
          this.$router.push({
            name: "login"
          });
        });
      },
      hide2nd() {
        this.$bvModal.hide("modal-logout");
      },
      confirmLogout() {
        this.$bvModal.show("modal-logout");
      },
    }
};
</script>

<style scoped>
.nav-wrapper {
  background-color: white;
  color: black;
  margin-top: 1px;
  height: inherit;
  padding-top: 17px;
  min-height: 70px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  overflow-y: visible
}
.nav-item-left-wrapper{
  display: flex;
  justify-content: start;
  overflow: auto;
  scrollbar-width: thin;
}
.link-nav{
  overflow-y: auto
}
.dashside {
  background-color: #263056;
  color: white;
  margin-top: -16px;
  height: 100%;
  padding-top: 10px;
  min-height: 70px;
  position: fixed;
  z-index: 999;
  width: 350px;
  overflow-y: auto
}
.dashtext {
  font-size: 25px;
  font-family: "Times New Roman", Times, serif;
  color: white;
}

.dashlink {
  display: flex;
  font-size: 20px;
  margin-top: 2rem;
  text-decoration: none;
  color: white;
  padding: 3px;
}
.img-dp {
  width: 55px;
  height: 55px;
  display: inline-block;
  border-radius: 5px 5px;
}
.active {
  border-right: 20px solid #263056;
  color: #263056;
}
.mactive {
  color: white;
  border-right:20px solid red;
}

.sbb {
  height: 50px;
}

@media (max-width: 999px) {
  .navbody {
    background: #263056;
    height: 100vh
  }

  .module-text{
    font-size: 18px;
    padding-top: 10px
  }
}

@media screen and (min-width: 999px) {
  .sbb {
    display: none;
  }
}
</style>
